"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Radar;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _RadarModule = _interopRequireDefault(require("./Radar.module.scss"));

var _inputElements = require("../../../../inputElements");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
TODO: Tooltips:
World Map
Zoom In
Zoom Out
*/
var zoneX = -200;
var zoneY = -250;
var ZOOM_OUT_VALUE = 1;
var ZOOM_IN_VALUE = 1.7;
var TRANSITION_DURATION = 1;

function Radar(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useState = (0, _react.useState)(ZOOM_OUT_VALUE),
      _useState2 = _slicedToArray(_useState, 2),
      zoomLevel = _useState2[0],
      setZoomLevel = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      avatarRotation = _useState4[0],
      setAvatarRotation = _useState4[1];

  var renderMap = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _RadarModule.default.map,
      style: {
        backgroundPositionX: zoneX,
        backgroundPositionY: zoneY,
        transform: "scale(".concat(zoomLevel, ")"),
        transition: "all ".concat(TRANSITION_DURATION, "s")
      }
    });
  }, [zoomLevel]);
  var renderAvatarDir = (0, _react.useCallback)( // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  function () {
    var rotation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _RadarModule.default.avatarDir,
      style: {
        transform: "scale(".concat(zoomLevel, ") rotate(").concat(rotation, "deg)"),
        transition: "all ".concat(TRANSITION_DURATION, "s")
      }
    });
  }, [zoomLevel]); // TODO: requires major refactoring. consider zoneX + zoneY

  var renderElement = (0, _react.useCallback)( // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  function () {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "etc";
    var left = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var top = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var margin = 75 - 7 / 2;
    var leftPx = left - 7 * (zoomLevel - 1) / 2;
    var topPx = top - 7 * (zoomLevel - 1) / 2;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_RadarModule.default.element, _RadarModule.default[type]),
      style: {
        left: "".concat(leftPx, "px"),
        top: "".concat(topPx, "px"),
        marginLeft: "".concat(margin / zoomLevel, "px"),
        marginTop: "".concat(margin / zoomLevel, "px"),
        transition: "all ".concat(TRANSITION_DURATION, "s")
      }
    });
  }, [zoomLevel]);
  var renderElements = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        transform: "scale(".concat(zoomLevel, ")"),
        transition: "all ".concat(TRANSITION_DURATION, "s")
      }
    }, renderElement("etc", 7, 10), renderElement("etc", 0, -15), renderElement("etc", -10, -50), renderElement("partypos", 0, -40), renderElement("questHard", 30, 15));
  }, [renderElement, zoomLevel]);
  var renderFrame = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _RadarModule.default.windowFrame,
      style: {
        transform: "scale(1) !important"
      }
    }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
      type: _inputElements.EButtonType.MM_WORLDMAP,
      className: _RadarModule.default.btnWorldMap
    }), zoomLevel !== ZOOM_OUT_VALUE && /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
      type: _inputElements.EButtonType.MM_SHRINK,
      onClick: function onClick() {
        setZoomLevel(ZOOM_OUT_VALUE);
      },
      className: (0, _classnames.default)(_RadarModule.default.btnZoom, _RadarModule.default.btnZoomOut)
    }), zoomLevel !== ZOOM_IN_VALUE && /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
      type: _inputElements.EButtonType.MM_EXTEND,
      onClick: function onClick() {
        setZoomLevel(ZOOM_IN_VALUE);
      },
      className: (0, _classnames.default)(_RadarModule.default.btnZoom, _RadarModule.default.btnZoomIn)
    }));
  }, [zoomLevel]); // TODO: just for showcase, remove it later

  (0, _react.useEffect)(function () {
    var intervalInstance = setInterval(function () {
      setAvatarRotation(avatarRotation + 3);
    }, 100);
    return function () {
      return clearInterval(intervalInstance);
    };
  }, [avatarRotation]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_RadarModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _RadarModule.default.floatingElements
  }, renderMap(), renderAvatarDir(avatarRotation), renderElements()), renderFrame());
}